import React from 'react';
import { ContainerBase } from '../containers';
import clsx from 'clsx';
import { Title } from '../title';
import { CarouselComponent } from './CarouselComponent';
import { SwiperSlide } from 'swiper/react';
import { SplitColorTitle } from '@/components/common/split-color-title';
import { CardTestimonial } from '../components/CardTestimonial';

export const Testimonial = (): React.JSX.Element => {
	const testimonials = [
		{
			description:
				"Lowey's team showed the utmost professionalism when working on my case and were diligent throughout. My lawyers explained the process in detail and were always available to answer any questions I had. ",
			name: 'Ted Hozza',
		},
		{
			description:
				'The Lowey data privacy team has been great to work with. They walked me through the case every step of the way and answered any questions I had. I would definitely recommend them.',
			name: 'Nick Rapak',
		},
		{
			description:
				'The Lowey folks were great to work with. They kept me apprised about updates in my case through the entire process.',
			name: 'Michael Kilgore',
		},
		{
			description:
				'The Lowey team was a pleasure to work with. They kept me updated about my case every step up the way, including settlement. I would highly recommend them.',
			name: 'Edward del Hierro',
		},
	];
	return (
		<>
			<ContainerBase
				className={clsx(
					'space-y-16 pb-9 md:pb-16 pt-14 lg:pt-28',
					'flex flex-col items-center w-full'
				)}
			>
				<Title
					className="lg:max-w-[578px] xl:max-w-[768px]"
					description="Trusted by clients nationwide."
				>
					Testimonial
				</Title>
			</ContainerBase>
			<div className="flex w-full mt-0 relative lg:pl-[88px] 3xl:pl-[252px] pb-12 md:pb-16">
				<div className="hidden lg:flex w-[378px] shrink-0 border-r-2 mt-10 border-primary h-[345px] items-center">
					<SplitColorTitle
						blackText="See what they say"
						colorText="about us"
						textSize="headline-48"
						className="max-w-[327px] leading-none"
					/>
				</div>
				<div className="max-w-full overflow-hidden px-2 lg:px-0">
					<CarouselComponent
						id="testimonials"
						amountPages={testimonials.length}
					>
						{testimonials.map((value, index) => (
							<SwiperSlide key={index}>
								<CardTestimonial
									name={value.name}
									description={value.description}
								/>
							</SwiperSlide>
						))}
					</CarouselComponent>
				</div>
			</div>
		</>
	);
};
